import { api } from '../axios'

export const getUser = async (id) =>  await api.get(`/user/getUserById/${id}`);

export default {
  getUser
}